import { isEmbedMode } from "../embedMode";
import { reportExpiredEmbedToken } from "../embedTokenRecover";
import { isValidJWT } from "./isValidJWT";

// Same answer as `!!token && isValidJWT(token)`. In an embedded frame a present but
// expired token is also reported, so the frame asks the portal for a fresh session
// instead of dropping the call without a trace. `source` only labels the log line.
export function hasUsableJWT(token: string | null | undefined, source: string): boolean {
  if (!token) return false;
  if (isValidJWT(token)) return true;
  if (isEmbedMode()) reportExpiredEmbedToken(token, source);
  return false;
}
